<template>
    <div class="link-item">
        <el-tooltip effect="dark" :content="copied?'Copied to clipboard':'Copy'" placement="top">
            <div class="copy-icon" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="resetCopyStatus" @mouseenter="resetCopyStatus" >
                <IconBase
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#E7E6FA'"
                >
                    <IconCopy />
                </IconBase>
            </div>
        </el-tooltip>
        <a :href="externalLink" class="shared-link" @click.prevent="openLink">{{ link }}</a>
    </div>
</template>

<script>
import IconBase from '../IconBase'
import IconCopy from '../icons/IconCopy'
export default {
    props: ['link'],
    components: {
        IconBase,
        IconCopy
    },
    data(){
        return {
            copied: false,
            externalLink: this.link
        }
    },
    mounted(){
        this.updateExternalLink();
    },
    methods:{
        updateExternalLink(){
            try {
                new URL(this.link);
            } catch (error) {
                try {
                    const updatedUrl = `https://${this.link}`;
                    new URL(updatedUrl);
                    this.externalLink = updatedUrl;
                } catch (error) {
                    console.error("An error occurred:", error);
                }
            }
        },
        onCopy(){
            this.copied = true
        },
        resetCopyStatus(){
            this.copied = false
        },
        openLink(){ /* TODO: Repated in several places */
            const width = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

            const height = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;

            const popupWidth = width * 0.6
            const popupHeight = height * 0.6
            const offsetLeft = ( width - popupWidth ) * 0.5
            const offsetTop = ( height - popupHeight) * 0.5
            window.open(this.externalLink, '_blank', `location=yes,height=${popupHeight},width=${popupWidth},scrollbars=yes,status=yes,top=${offsetTop},left=${offsetLeft}`);
        }
    }
}
</script>

<style scoped>
.link-item {
    display: flex;
    margin-bottom: 25px;
}

.shared-link {
    color: #52B7CC;
    text-decoration: underline;
    font-size: 14px;
    font-weight: 18px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.copy-icon {
    margin-right: 20px;
}
</style>
